var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"title-container"},[_c('h1',{staticClass:"left-title"},[_vm._v("左侧标题")]),_c('h1',{staticClass:"middle-title"},[_vm._v("中间标题1111111111111111111111111111")]),_c('h1',{staticClass:"right-title"},[_vm._v("右侧标题")])])
}]

export { render, staticRenderFns }